export function isEmpty(uri) {
    return !uri || uri.trim() === '';
}

export function stripToRoot(value) {
    // remove protocol
    let strippedValue = value.replace(/http(s)?:\/\//i, '');

    // strip off query string
    strippedValue = strippedValue.split('?', 1).join('');

    // strip off hash
    strippedValue = strippedValue.split('#', 1).join('');

    // strip off domain
    if (!strippedValue.startsWith('/')) {
        const tokens = strippedValue.split('/');
        strippedValue = `/${tokens.slice(1).join('/')}`;
    }
    return strippedValue;
}

export function stripSegment(uri) {
    if (isEmpty(uri)) {
        return uri;
    }

    return uri.split('#')[0];
}

export function getUrlParts(url) {
    const root = stripToRoot(url);
    const parts = stripSegment(url).split(root);

    return parts;
}
